export enum WidgetCode {
    ViewDetailStyle = 'view-detail-style',
    FilterWidget = 'filter-widget',
    SortWidget = 'sort-widget',
    GenderFilterWidget = 'gender-filter-widget',
    CategoryFilterWidget = 'category-filter-widget',
    PriceRangeFilterWidget = 'price-range-filter-widget',
    ViewStyleInfo = 'view-style-info',
    BodyShapeFilterWidget = 'body-shape-filter-widget',
    BodyTypeFilterWidget = 'body-type-filter-widget',
    PurposeFilterWidget = 'purpose-filter-widget',
    PurposeSuggestionWidget = 'purpose-suggestion-widget',
    SearchConsumerWidget = 'search-consumer-widget',
    BrandsFilterWidget = 'brands-filter-widget',
    BottomPopupWidget = 'bottom-popup-widget',
    FilterConsumerWidget = 'filter-consumer-widget',
    LevelFilterWidget = 'level-filter-widget',
    ExpertiseFilterWidget = 'expertise-filter-widget',
    SearchStoreWidget = 'search-shopify-store',
    PreviewImage = 'preview-image',
    ConsumerFeedback = 'consumer-feedback',
    AuthWidget = 'auth-widget',
    CreateProfile = 'CreateProfile',
}
